(function() {
  // Store cutoff: ships same day if ordered before 4pm ET, Mon-Fri only.
  // Fri after cutoff and all weekend, the next carrier pickup is Monday,
  // so the badge names Monday explicitly rather than falling back to a
  // vague claim or promising an impossible "tomorrow".
  function getShipMessage() {
    var now = new Date();
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(now);

    var weekday, hour;
    parts.forEach(function(p) {
      if (p.type === 'weekday') weekday = p.value;
      if (p.type === 'hour') hour = parseInt(p.value, 10);
    });

    var CUTOFF_HOUR = 16; // 4pm ET

    // Saturday and Sunday: nothing moves until Monday.
    if (weekday === 'Sat' || weekday === 'Sun') {
      return 'Ships Monday';
    }
    // Friday past cutoff: the next pickup is Monday, not tomorrow.
    if (weekday === 'Fri') {
      return hour < CUTOFF_HOUR ? 'Ships Today' : 'Ships Monday';
    }
    // Monday through Thursday.
    return hour < CUTOFF_HOUR ? 'Ships Today' : 'Ships Tomorrow';
  }

  function makeBadge(shipMessage) {
    var badge = document.createElement('div');
    badge.className = 'pf-ready-to-ship';
    badge.innerHTML = '<span class="pf-ready-to-ship-dot"></span><span class="pf-ready-to-ship-text">' + shipMessage + '</span>';
    return badge;
  }

  function wireSync(btn, badge) {
    function sync() {
      var text = (btn.textContent || '').trim().toUpperCase();
      var soldOut = btn.disabled || text === 'SOLD OUT';
      badge.style.display = soldOut ? 'none' : 'flex';
    }
    sync();
    var observer = new MutationObserver(sync);
    observer.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  function initReadyToShip() {
    var tags = window.AWAY_PRODUCT_TAGS || [];
    var hasTag = tags.some(function(t) { return (t || '').toLowerCase() === 'ready-to-ship'; });
    if (!hasTag) return;

    var shipMessage = getShipMessage();

    // Desktop info panel + expanded mobile sheet (legacy .pf-info-side system)
    document.querySelectorAll('.pf-atc-button, .pf-mobile-atc-button').forEach(function(btn) {
      if (btn.dataset.readyToShipInit) return;
      btn.dataset.readyToShipInit = 'true';
      var badge = makeBadge(shipMessage);
      btn.parentNode.insertBefore(badge, btn);
      wireSync(btn, badge);
    });

    // Mobile persistent floating bar (.pf-mobile-layout system) -- this is
    // the actual visible add-to-cart control on real mobile viewports.
    // Insert above the whole button row (which also holds Shop Pay/etc.),
    // not just above the button itself, to match the reference layout.
    document.querySelectorAll('.pf-floating-atc-btn').forEach(function(btn) {
      if (btn.dataset.readyToShipInit) return;
      btn.dataset.readyToShipInit = 'true';
      var row = btn.closest('.pf-floating-btn-row') || btn.parentNode;
      var badge = makeBadge(shipMessage);
      badge.classList.add('pf-ready-to-ship--floating');
      row.parentNode.insertBefore(badge, row);
      wireSync(btn, badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadyToShip);
  } else {
    initReadyToShip();
  }
  // Re-run for late-rendering DOM (mobile sheet, section re-renders, etc.)
  setTimeout(initReadyToShip, 500);
  setTimeout(initReadyToShip, 1200);
  window.addEventListener('resize', initReadyToShip);
})();